import api from '@/services/api.js';

export default {
  //namespaced: true,
  state: {
    polls: [],
    livePoll: null,
    activePoll: null
  },
  mutations: {
    SET_POLLS(state, payload) {
      state.polls = payload;
    },
    SOCKET_POLL_COUNT_CHANGE(state, payload) {
      // only realtime update polls we've launched
      //if (state.activePoll._id === payload._id) {
      state.activePoll = payload;
      //}
    },
    SET_ACTIVE_POLL(state, payload) {
      state.activePoll = payload;
    }
  },
  actions: {
    async loadPolls({ rootState, commit }) {
      commit('SET_LOADING', true);
      const polls = await api.getPolls(rootState.events.event._id);
      commit('SET_POLLS', polls);
      commit('SET_LOADING', false);
      return polls;
    },
    async loadPoll({ commit }, pollId) {
      commit('SET_LOADING', true);
      const poll = await api.getPoll(pollId);
      commit('SET_LOADING', false);
      return poll;
    },
    async createPoll({ rootState, commit }, poll) {
      poll.eventId = rootState.events.event._id;
      await api.createPoll(poll);
      commit('SET_MESSAGE', {
        content: 'Poll Created',
        color: 'success'
      });
    },
    async savePoll({ commit }, poll) {
      //poll.eventId = rootState.events.event._id;
      await api.savePoll(poll._id, poll);

      commit('SET_MESSAGE', {
        content: 'Poll Saved!',
        color: 'success'
      });
    },
    async deletePoll({ commit }, poll) {
      await api.deletePoll(poll._id);
      commit('SET_MESSAGE', {
        content: 'Poll Deleted!',
        color: 'success'
      });
    },
    reorderPolls(context, orderArray) {
      api.reorderPolls(orderArray);
    }
    // async saveAnswers(context, data) {
    //   const result = await client.put(
    //     `/polls/answers/${data.pollId}`,
    //     data.answers
    //   );
    //   return result.data;
    // },
    // async loadAnswers(context, pollId) {
    //   const result = await client.get(`/polls/answers/${pollId}`);
    //   return result.data;
    // },
    // async deleteAnswer(context, data) {
    //   const result = await client.delete(
    //     `/polls/answers/${data.pollId}/${data.answerId}`
    //   );
    //   return result.data;
    // }
  }
};
